import React from "react";
import { withRouter } from 'react-router-dom';
import { getQueryStringParams } from "sharedUtils/navUtils";
import RakutenMerchantRawData from './RakutenMerchantRawData';
import AvantLinkMerchantRawData from './AvantLinkMerchantRawData';
import ImpactMerchantRawData from './ImpactMerchantRawData';
import CJAffiliateMerchantRawData from './CjAffiliateMerchantRawData';
import PartnerizeMerchantRawData from './PartnerizeMerchantRawData';
import AwinMerchantRawData from './AwinMerchantRawData';
import AscendMerchantRawData from "./AscendMerchantRawData";
import ShareASaleMerchantRawData from "./ShareASaleMerchantRawData";
import SovrnMerchantRawData from "./SovrnMerchantRawData";
import FlexoffersMerchantRawData from "./FlexoffersMerchantRawData";
import DigiDipMerchantRawData from "./DigiDipMerchantRawData";

class AffiliateMerchantRawData extends React.Component {

    componentDidMount = async () => {
        let scrollOptions = {
            left: 0,
            top: 0,
            behavior: 'auto'
        }
    }

    renderAffiliateComponent = () => {
        const { affiliateProgramManager } = this.props;

        switch (affiliateProgramManager.name) {
            case "CJAffiliate":
                return <CJAffiliateMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Rakuten":
                return <RakutenMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Ascend":
                return <AscendMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Awin":
                return <AwinMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "AvantLink":
                return <AvantLinkMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Impact":
                return <ImpactMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Partnerize":
                return <PartnerizeMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "ShareASale":
                return <ShareASaleMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Sovrn":
                return <SovrnMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Flexoffers":
                return <FlexoffersMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "DigiDip":
                return <DigiDipMerchantRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Amazon":
                return <h1 style={{ background: "white", textAlign: "center", }}>Amazon has no merchant raw data</h1>;
            default:
                return <h1>Unknown Affiliate Program</h1>;
        }
    }

    render() {
        return (
            <>
                {this.renderAffiliateComponent()}
            </>
        )
    }
}

export default withRouter(AffiliateMerchantRawData);
